
import { MapLocation } from '@/types/location';

// RQ Arena Center Locations
export const rqArenaCenters: MapLocation[] = [
  {
    id: 49001,
    name: "RQ Arena - Riyadh (King Faisal)",
    type: "Game Center",
    devices: 10,
    coordinates: [24.77082866266292, 46.76753149140576],
    region: "Riyadh",
    mediaOwner: "Alan",
    mediaKind: "Indoor",
    screenType: "Portrait Screens",
    gender: "Unisex",
    ageRange: "16-45",
    orientation: "Portrait",
    segment: "Game"
  }
];
